import { UUIDPathRegex } from '@cbgms/base/utils/uuid'
import { buildProductDetailsDialogPath } from 'app/products/components/ProductListV2/ProductDetails/routes'
import { generatePath } from 'react-router-dom'

export const pathWholesalerDashboard = () => `/wholesaler`
export const urlWholesalerDashboard = () => generatePath(pathWholesalerDashboard())

export const pathCMSNewsList = () => `/wholesaler/:wholesalerUUID(${UUIDPathRegex})/news`
export const urlCMSNewsList = (wholesalerUUID: string) =>
  generatePath(pathCMSNewsList(), {
    wholesalerUUID
  })

export const pathCMSNewsItem = () => `/wholesaler/:wholesalerUUID(${UUIDPathRegex})/news/:newsItemID`
export const urlCMSNewsItem = (wholesalerUUID: string, newsItemID: string) =>
  generatePath(pathCMSNewsItem(), {
    wholesalerUUID,
    newsItemID
  })

export const pathCMSPromotionsList = () => `/wholesaler/:wholesalerUUID(${UUIDPathRegex})/promotions`
export const urlCMSPromotionsList = (wholesalerUUID: string) =>
  generatePath(pathCMSPromotionsList(), {
    wholesalerUUID
  })

export const pathCMSPromotionItem = () => `/wholesaler/:wholesalerUUID(${UUIDPathRegex})/promotions/:promotionItemID`
export const urlCMSPromotionItem = (wholesalerUUID: string, promotionItemID: string) =>
  generatePath(pathCMSPromotionItem(), {
    wholesalerUUID,
    promotionItemID
  })

export const pathCMSPromotionItemProductDetail = (basePath: string) => buildProductDetailsDialogPath(basePath)
export const urlCMSPromotionItemProductDetail = (basePath: string, idType: string, productID: string) =>
  generatePath(pathCMSPromotionItemProductDetail(basePath), { idType, productID })
